export default [
  {
    path: '/word-pool',
    component: () => import('./views/Index'),
    name: 'word-pool',
    redirect: { name: 'word-pool-list' },
    children: [
      {
        path: 'words',
        name: 'word-pool-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
